import { defaultBadgeVariants } from './defaultBadgeVariants';
import { defaultButtonVariants } from './defaultButtonVariants';
import { defaultTagVariants } from './defaultTagVariants';
export var defaultThemeVariants = {
    Alert: defaultBadgeVariants,
    Badge: defaultBadgeVariants,
    Button: defaultButtonVariants,
    Tag: defaultTagVariants,
};
//# sourceMappingURL=defaultThemeVariants.js.map